type Value = string | number | null | undefined;

export function maybeString(value: Value): string | undefined {
  return value ? value.toString() : undefined;
}

export function maybeNumber(value: Value): number | undefined {
  return value ? Number.parseInt(value.toString(), 10) : undefined;
}
